import { useState } from 'react';
import LeadForm from './LeadForm';
import HomeBanner from './HomeBanner';



function MidSection() {

    const [activeTab, setActiveTab] = useState("one");
    return (
        <>
            <section className="home-banner">



                <div className="left-content">
                    <HomeBanner />
                </div>
                {/* <div className="timerbox">
                    <LeadForm />
                </div> */}
            </section>
            <section className="ils d-none">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h2 className="heading">Insurance Learning Space</h2>
                            <p className="text">Explore <i>Insurance Learning Space</i> to grasp the benefits & boost your
                                efficiency for
                                selling policies digitally with Digital First Insurance Platform.</p>
                        </div>
                        <div className="col-md-6">
                            <div className="know_more">
                                <a href="https://marketing.bajajcapitalinsurance.com/insurance-learning-space" target="_blank" className="btn">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ILS section  --> */}

            {/* <!-- Brand of the year  --> */}
            <section className="brand">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h2 className="heading">Brand of the Year 2024</h2>
                            <p className="text">Thank you for choosing Bajaj Capital Insurance Broking Ltd. Your trust inspires our
                                excellence.</p>
                        </div>
                        <div className="col-md-4 position-relative text-center">
                            <img src="/assets/images/brand-award.png" width="300px" className="award-image" alt="brand-award" />
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Brand of the year  -->
    <!-- testimonial  section  --> */}
            <section className="testimonial">
                <div className="container">
                    <div className="heading">
                        <h3>Here's why our PEOPLE love us</h3>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="testimonial-card">
                                <img src="/assets/images/icons/quote.svg" className="quote" alt="quote" />
                                <img src="/assets/images/kirti_kashyap.png" className="user-img" alt="" />
                                <p className="content">"The services offered at Bajaj Capital shine brightly as it caters to
                                    each individual's needs."</p>
                                <p className="name">Kirti Kashyap</p>
                                <p className="designation">Senior Manager, New Delhi</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="testimonial-card">
                                <img src="/assets/images/icons/quote.svg" className="quote" alt="quote" />
                                <img src="/assets/images/surajit_banerjee.png" className="user-img" alt="" />
                                <p className="content">“This is our expertise at Bajaj Capital. We give a solution-based
                                    approach to by identifying individual’s needs and providing our services
                                    with a Client-Centric approach.”</p>
                                <p className="designation">LA Premier, Mumbai</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="testimonial-card">
                                <img src="/assets/images/icons/quote.svg" className="quote" alt="quote" />
                                <img src="/assets/images/pinky_roy.png" className="user-img" alt="" />
                                <p className="content">“When I’m sitting with my customer, I want a detailed explanation of
                                    insurance jargon that the B2B portal has resolved for me.”</p>
                                <p className="nameP">Pinky Roy</p>
                                <p className="designation">
                                    RM, New Delhi</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- testimonial  section  -->

    <!-- cta  section  --> */}
            <section className="cta">
                <div className="container">
                    <div className="cta_div">
                        <div className="row mob_direction">
                            <div className="col-md-7 mob_bg_white">
                                <div className="cta-data">
                                    <h4>Ready to compare, sell and serve better than ever?</h4>
                                    <a href="https://pos.bajajcapitalinsurance.com/" target="_blank" className="btn">Join Us Now<em><img src="/assets/images/Arrow.png" className="arrow" alt="arrow" /></em></a>                            </div>
                            </div>
                            <div className="col-md-5">
                                <img src="/assets/images/man_with_bag.png" className="manwithbag" alt="manwithbag" />                        </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- cta  section  -->

    <!-- TIME TO LEVEL UP WITH BAJAJ CAPITAL INSURANCE  section  --> */}

            <section className="insurance">
                <div className="heading">
                    <h3>TIME TO LEVEL UP WITH BAJAJ CAPITAL INSURANCE BROKING LIMITED</h3>
                </div>
                <div className="container position-relative">
                    <img src="/assets/images/insurance_dotted.png" className="dotted" alt="" />
                    <div className="tab">
                        {/* TAB 1 */}
                        <div className="tabs">
                            <button
                                className={`tablinks btn ${activeTab === "one" ? "btn-active" : ""
                                    }`}
                                onClick={() => setActiveTab("one")}
                            >
                                <img src="/assets/images/icons/Group1.svg" alt="group" />

                                <div className="content">
                                    <small className="activeA">What is</small>
                                    <small className="activeB">Term Insurance?</small>
                                </div>

                                <img src="/assets/images/Arrow.png" alt="arrow" className="whtarrow" />
                                <img
                                    src="/assets/images/icons/black_arrow.svg"
                                    alt="arrow"
                                    className="blkarrow"
                                />
                            </button>

                            {activeTab === "one" && (
                                <div className="tabcontent" id="one">
                                    <div class="card-data">
                                        <h4>Term Insurance</h4>
                                        <p>Life is too unpredictable, and uncertainties can also rip a person off
                                            emotionally, financially, and physically. This is because no one
                                            controls one's disease; neither can anyone predict it. Therefore, the
                                            breadwinner's death can cause disastrous turbulence in the family
                                            member's life. Term insurance plays a vital role in your life to solve
                                            these problems. Moreover, term plans are an excellent way to build
                                            a financial safety net and are the most straightforward and
                                            affordable type of term life insurance. It will help your family to
                                            settle your loans and pay off specific requirements in your absence.
                                            The death benefits are paid to the beneficiary or the nominee only
                                            upon the insured's death. Therefore, in simple words, the death
                                            benefits are zero if the insured dies after the policy has expired.</p>
                                        <h4>Documents required to file a Term
                                            Insurance claim:</h4>
                                        <h4>In case of a natural death :</h4>
                                        <ul>
                                            <li>Term Insurance policy document</li>
                                            <li>Duly signed and filled claim forms (As provided by the insurance company - To
                                                download, visit their official website)</li>
                                            <li>Original or Copy of the Life Assured's Death Certificate</li>
                                            <li>Claimant's statement
                                            </li>
                                            <li>Any other relevant document as requested by the insurance company.
                                            </li>
                                        </ul>
                                        <h4>In case of an accidental death</h4>
                                        <ul>
                                            <li>Police FIR report, Police Inquest Form and Final Police Investigation Report
                                            </li>
                                            <li>Medical attendant's certificate or Attending Doctor’s Statement</li>
                                            <li>Hospital Certificate and medical reports including admission and discharge
                                                summary of the life assured, death summary, test reports, etc.</li>
                                            <li>Postmortem report
                                            </li>
                                            <li>Claimant’s statement
                                            </li>
                                            <li>Any other relevant documentation as requested by the insurance company. The
                                                Claims Assistance team of the insurance company will verify all the supportive
                                                documents and nominee declaration. Depending on the situation, the claimant or
                                                nominee may be required to submit additional documents.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* TAB 2 */}
                        <div className="tabs">
                            <button
                                className={`tablinks btn ${activeTab === "two" ? "btn-active" : ""
                                    }`}
                                onClick={() => setActiveTab("two")}
                            >
                                <img src="/assets/images/icons/Group2.svg" alt="group" />

                                <div className="content">
                                    <small className="activeA">What is</small>
                                    <small className="activeB">Health Insurance?</small>
                                </div>

                                <img src="/assets/images/Arrow.png" alt="arrow" className="whtarrow" />
                                <img
                                    src="/assets/images/icons/black_arrow.svg"
                                    alt="arrow"
                                    className="blkarrow"
                                />
                            </button>

                            {activeTab === "two" && (
                                <div className="tabcontent" id="two">
                                    <div class="card-data">
                                        <h4>Health Insurance</h4>
                                        <p>Health insurance is a contract between you and your insurance company that governs
                                            your health care. It covers medical and surgical expenses on behalf of policyholders
                                            in the event of a medical emergency or illness. A health insurance policy remains
                                            active even when a claim has been made until the sum insured limit is exhausted.
                                            Besides covering hospitalisation expenses, it reimburses pre and
                                            post-hospitalization expenses, ambulance fees, pharmacy bills, etc. Health insurance
                                            is a contract between you and your insurance company. You buy a plan, and the
                                            company agrees to pay part of your medical costs when you get sick or hurt. Any
                                            insurance solicitation in India is governed by IRDA (Insurance Regulatory &
                                            Development Authority), formed under the IRDA Act of 1999 as a statutory legislative
                                            government body.</p>
                                        <h4>Types of Insurance:</h4>
                                        <ul>
                                            <li>Hospitalization Plans: Hospitalization insurance provides coverage for hospital
                                                confinement due to illness, accidents, intensive care, outpatient medical
                                                treatment, surgery, or hospital-related activity that involves the insured’s
                                                health, etc.</li>

                                            <li>Family Floater Plans: In a family floater plan, any family member can use the
                                                insurance policy limit. For example, if a policyholder is buying a policy for
                                                three members of the household, then any member can utilise the entire limit of
                                                the sum insured.</li>

                                            <li>Senior Citizen Plans: Senior citizen insurance covers citizens aged between 60
                                                and 80. An unexpected medical cost can create a financial crisis; therefore, it
                                                is better to get seniors between 60-80 age medically covered in the Senior
                                                citizen plans.</li>

                                            <li>Maternity Plans: Maternity insurance is a type of health insurance that provides
                                                maternity coverage. Maternity plans come with pre and post-hospitalization
                                                costs.
                                            </li>
                                            <li>Critical Illness Plans: Critical Illness Insurance covers life-threatening
                                                conditions defined and specified in terminal illness. Critical illness insurance
                                                is designed to ease the financial pressures of suffering from a severe illness.
                                            </li>
                                        </ul>
                                        <h4>Comprehensive Insurance:</h4>
                                        <p>A comprehensive policy is more expensive, but not only does it cover damage to the
                                            insured car and driver, but also the insured vehicle’s third-party liability. Losses
                                            incurred due to theft, natural calamities like fire, explosion, accident,
                                            self-ignition or lightning, terrorist activity, or damage in transit by road, rail,
                                            inland waterway, lift, elevator, or air are all covered under this.</p>
                                        <h4>Importance of Health Insurance</h4>
                                        <ul>
                                            <li>Protection of health</li>
                                            <li>Financial Support at the time of emergency</li>
                                            <li>Protection against rising health expenses</li>
                                            <li>Productive utilisation of own savings
                                            </li>
                                            <li>Source of credit
                                            </li>
                                        </ul>
                                        <h4>Key factors to consider before buying a Health Insurance</h4>
                                        <ul>
                                            <li>Room rent limit and ICU limits.</li>
                                            <li>Co-payment</li>
                                            <li>Hospital network</li>
                                            <li>Claims loading
                                            </li>
                                            <li>Renewability age</li>
                                            <li>Disease wise capping</li>
                                            <li>Unique features</li>
                                            <li>Industry claims Settlement ratio</li>
                                            <li>Daycare procedures</li>
                                            <li>Pre existing waiting period</li>
                                            <li>Bonus</li>
                                        </ul>
                                        <h4>Features:</h4>
                                        <ul>
                                            <li>Pre-hospitalization expenditure</li>
                                            <li>Post-hospitalization expenditures</li>
                                            <li>Coverage for Critical Illness</li>
                                            <li>Ambulance Coverage</li>
                                            <li>Save tax up to Rs. 55,000/- under section 80D</li>
                                            <li>Cashless Hospitalization</li>
                                            <li>Maternity and OPD coverage</li>
                                        </ul>
                                        <h4>Rights &amp; Conditions</h4>
                                        <h4>Rights</h4>
                                        <ul>
                                            <li> You can port any individual/ family policies</li>
                                            <li>Your new insurer has to give you credit for a waiting period for pre-existing
                                                conditions you have gained with the old insurer.</li>
                                            <li>Your new insurer has to insure you at least up to the sum insured under the old
                                                policy.</li>
                                            <li>The two insurers should complete the porting per the timelines prescribed in the
                                                IRDA (Protection of Policyholders’ Interests) Regulations and guidelines.</li>
                                        </ul>
                                        <h4>Conditions</h4>
                                        <ul>
                                            <li>You can port the policy only at the juncture of renewal. That is, the new
                                                Insurance period will be with the new Insurance company</li>
                                            <li>Apart from the waiting period credit, all other terms of the new policy,
                                                including the premium, are at the discretion of the new insurance company. At
                                                least 45 days before your renewal is due.
                                            </li>
                                        </ul>
                                        <h4>Please Note :</h4>
                                        <p>Claims will be processed on receipt of all required documents, and additional
                                            documents or information, if required, will be called for after scrutiny of the
                                            claim. A cheque will be dispatched to you if the claim is admissible. If not, a
                                            repudiation letter will be sent to you. The turnaround time for reimbursement claims
                                            is 20 days from the date of receipt of all documents.</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* TAB 3 */}
                        <div className="tabs">
                            <button
                                className={`tablinks btn ${activeTab === "three" ? "btn-active" : ""
                                    }`}
                                onClick={() => setActiveTab("three")}
                            >
                                <img src="/assets/images/icons/Group4.svg" alt="group" />

                                <div className="content">
                                    <small className="activeA">What is</small>
                                    <small className="activeB">Car Insurance?</small>
                                </div>

                                <img src="/assets/images/Arrow.png" alt="arrow" className="whtarrow" />
                                <img
                                    src="/assets/images/icons/black_arrow.svg"
                                    alt="arrow"
                                    className="blkarrow"
                                />
                            </button>

                            {activeTab === "three" && (
                                <div className="tabcontent" id="three">
                                    <div class="card-data">
                                        <h4>Car Insurance</h4>
                                        <p>Motor insurance helps protect your car from unprecedented hazards like accidents,
                                            theft, fire, floods, vandalism, and other such scenarios. It is a contract between
                                            the motor vehicle owner and an insurance company to provide financial aid to the
                                            former to undertake repairs for damage or treat injuries in the event of a mishap.
                                            In return for the premium that the motor vehicle owner pays, the insurance company
                                            reimburses the costs of repairs, third-party losses, and treatment for injuries.
                                            Insurance is classified into comprehensive and third-party insurance.</p>
                                        <h4>Third-Party Cover</h4>
                                        <p>This type of insurance is mandatory in India for every car owner and driver. It
                                            provides financial protection for any loss or damage caused to another person,
                                            property, or vehicle because of your 4-wheeler. The third-party premium rate depends
                                            on the engine cubic capacity of your 4-wheeler. Such rates are fixed by the IRDAI
                                            and are revised every year or so. Personal Accident Insurance for the primary
                                            driver:If you opt for a comprehensive auto insurance policy in India, you will also
                                            receive a compulsory personal accident cover for the owner-driver. Save Money: You
                                            compare different quotes and choose the plan that best suits your requirements. </p>
                                        <h4>Comprehensive Insurance:</h4>
                                        <p>A comprehensive policy is more expensive, but not only does it cover damage to the
                                            insured car and driver, it also covers the insured vehicle’s third-party liability.
                                            Losses incurred due to theft, natural calamities like fire, explosion, accident,
                                            self-ignition or lightning, terrorist activity, or damage in transit by road, rail,
                                            inland waterway, lift, elevator, or air are all covered under this.</p>

                                    </div>
                                </div>
                            )}
                        </div>

                        {/* TAB 4 */}
                        <div className="tabs">
                            <button
                                className={`tablinks btn ${activeTab === "four" ? "btn-active" : ""
                                    }`}
                                onClick={() => setActiveTab("four")}
                            >
                                <img src="/assets/images/icons/Group3.svg" alt="group" />

                                <div className="content">
                                    <small className="activeA">What is</small>
                                    <small className="activeB">Bike Insurance?</small>
                                </div>

                                <img src="/assets/images/Arrow.png" alt="arrow" className="whtarrow" />
                                <img
                                    src="/assets/images/icons/black_arrow.svg"
                                    alt="arrow"
                                    className="blkarrow"
                                />
                            </button>

                            {activeTab === "four" && (
                                <div className="tabcontent" id="four">
                                    <div class="card-data">
                                        <h4>Bike Insurance</h4>
                                        <p>Motor insurance helps protect your 2-wheeler from unprecedented hazards like
                                            accidents, theft, fire, floods, vandalism, and other such scenarios. It is a
                                            contract between the motor vehicle owner and an insurance company to provide
                                            financial aid to the former to undertake repairs for damage or treat injuries in the
                                            event of a mishap. In return for the premium that the motor vehicle owner pays, the
                                            insurance company reimburses the costs of repairs, third-party losses, and treatment
                                            for injuries. Insurance is classified into comprehensive and third-party insurance.
                                        </p>
                                        <h4>Third-Party Cover</h4>
                                        <p>This type of insurance is mandatory in India for every 2-wheeler owner and driver. It
                                            provides financial protection for any loss or damage caused to another person,
                                            property, or vehicle because of your 2-wheeler. The third-party premium rate depends
                                            on the engine cubic capacity of your 2-wheeler. Such rates are fixed by the IRDAI
                                            and are revised every year or so. Personal Accident Insurance for the primary
                                            driver:If you opt for a comprehensive auto insurance policy in India, you will also
                                            receive a compulsory personal accident cover for the owner-driver. Save Money: You
                                            compare different quotes and choose the plan that best suits your requirements. </p>
                                        <h4>Comprehensive Insurance:</h4>
                                        <p>A comprehensive policy is more expensive, but not only does it cover damage to the
                                            insured vehicle and driver, it also covers the insured vehicle’s third-party
                                            liability. Losses incurred due to theft, natural calamities like fire, explosion,
                                            accident, self-ignition or lightning, terrorist activity, or damage in transit by
                                            road, rail, inland waterway, lift, elevator, or air are all covered under this.</p>

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </section>

            {/* <!-- TIME TO LEVEL UP WITH BAJAJ CAPITAL INSURANCE  section  -->

    <!-- WHY BAJAJ CAPITAL INSURANCE?  section  --> */}
            <section className="capital">
                <div className="container">
                    <div className="heading">
                        <h3>WHY BAJAJ CAPITAL INSURANCE BROKING LIMITED ?</h3>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="cap-card">
                                <img src="/assets/images/icons/capital-1.svg" alt="capital" />
                                <div className="cap-data">
                                    <h3 className="heading">Superior Insurance Assistance</h3>
                                    <p className="text">Guidance from broker-qualified persons for appropriate product
                                        selection. We are there whenever you need us.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="cap-card">
                                <img src="/assets/images/icons/capital-2.svg" alt="capital" />
                                <div className="cap-data">
                                    <h3 className="heading">Intelligent recommendations</h3>
                                    <p className="text">We are committed to getting you the right product by understanding your
                                        requirements better.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="cap-card">
                                <img src="/assets/images/icons/capital-3.svg" alt="capital" />
                                <div className="cap-data">
                                    <h3 className="heading">Hassle-free claim settlement</h3>
                                    <p className="text">We've worked hard to make paperwork hassle-free and assure to assist you
                                        in the negotiation of claims.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    );
}

export default MidSection;
